'use strict'

angular
  .module('basalteApp')
  .constant('BAS_CONNECTION', {
    REBOOT_REASON_RESTART: 'rebootReasonRestart',
    REBOOT_REASON_UPDATE: 'rebootReasonUpdate'
  })
